import { render, staticRenderFns } from "./WelcomeDash.vue?vue&type=template&id=8f2c909e&"
import script from "./WelcomeDash.vue?vue&type=script&lang=js&"
export * from "./WelcomeDash.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeDash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports